import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EnvironmentService } from "./environment.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private http: HttpClient, private env: EnvironmentService) {}

  getNotificationsForUser() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "NotificationInfoes";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  addNotification(id) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "NotificationInfoes/AddNotification" +
      id;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, { headers: headers });
  }

  updateAllNotifications() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "NotificationInfoes/UpdateAllNotifications";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, { headers: headers });
  }

  updateNotification(id, isRemoved, isViewed) {
    try {
      let status = "viewed";
      if (isRemoved) {
        status = "removed";
      }
      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "NotificationInfoes/Notification/" +
        id +
        "/" +
        status;

      let headers = new HttpHeaders();
      headers = headers
        .set("Content-Type", "application/json; charset=utf-8")
        .set("Cache-Control", "no-cache");
      const upload$ = this.http.put<any>(baseUrl, null, {
        headers: headers,
      });
      return upload$;
    } catch (Error) {}
  }

  clearAllNotification(isRemoved) {
    let status = "viewed";
    if (isRemoved) {
      status = "removed";
    }
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "NotificationInfoes/RemoveAllNotifications/" +
      status;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, { headers: headers });
  }

  getProgressUpdateForNotification(id: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "NotificationInfoes/GetProgressUpdateForNotification/" +
      id;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }
}
